<template>
	<AsiDialogFormLayout :icon="icons.move" :title="$t('paymentType.terms.create')"
	                     :open="open" :loading="loading" :valid="valid" :errors="errors"
	                     @save="requestSave" @cancel="cancel" unwrapped scrollable>
		<v-card-text class="pa-0">
			<v-form v-if="model !== null" v-model="valid">
				<div class="pa-6">
					<TranslatedValueFormPart :label="$t('paymentType.name')" :model="model.name" required/>
				</div>
				<v-divider/>
				<div class="pa-6">
					<TranslatedValueFormPart :label="$t('paymentType.description')" :model="model.description"/>
				</div>
				<v-divider/>
				<div class="pa-6">
					<v-row>
						<v-col>
							<AsiTextField v-model="model.code" :rules="model.rules('code')"
							              :label="$t('paymentType.code')" :placeholder="$t('paymentType.code')"
							              class="input-required" clearable/>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<AsiTextField v-model="model.paymentProviderCode" :rules="model.rules('paymentProviderCode')"
							              :label="$t('paymentType.paymentProviderCode')" :placeholder="$t('paymentType.paymentProviderCode')"
							              clearable/>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<AsiTextField v-model="model.externalId" :rules="model.rules('externalId')"
							              :label="$t('paymentType.externalId')" :placeholder="$t('paymentType.externalId')" clearable/>
						</v-col>
					</v-row>
				</div>
				<v-divider/>
				<div class="pa-6">
					<p><strong>{{ $t('paymentType.allowedCustomerTypes') }}</strong></p>
					<v-data-table
						v-model="selectedCustomerTypes"
						:headers="customerTypesHeaders"
						:items="customerTypes"
						item-key="index"
						show-select
					>
						<template v-slot:item.label="{item}">
							<td>{{ EnumHelper.textFromValue(CustomerType, item.index, true) }}</td>
						</template>
					</v-data-table>
				</div>
			</v-form>
		</v-card-text>
	</AsiDialogFormLayout>
</template>

<script lang="ts">
	import {Component, Emit} from "vue-property-decorator";
	import AsiDialogForm from "@/components/common/AsiDialogForm.vue";
	import AsiDialogFormLayout from "@/components/common/AsiDialogFormLayout.vue";
	import AsiTextField from "@/components/common/AsiTextField";
	import TranslatedValueFormPart from "@/components/translated-value/admin/TranslatedValueFormPart.vue";
	import PaymentTypeCreate from "@/models/payment-type/PaymentTypeCreate";
	import AsiCheckbox from "@/components/common/AsiCheckbox";
	import {CustomerType} from "@/helpers/constants";
	import EnumHelper from "../../../helpers/EnumHelper";
	import AsiListTableHeader from "@/components/common/AsiListTableHeader";

	@Component({
		components: {AsiCheckbox, TranslatedValueFormPart, AsiTextField, AsiDialogFormLayout}
	})
	export default class PaymentTypeCreateDialog extends AsiDialogForm {

		private model: PaymentTypeCreate = new PaymentTypeCreate();
		private customerTypes: {
			'index': CustomerType
		}[] = EnumHelper.toArray(CustomerType).map(ct => ({'index': Number(ct.value)}));
		private selectedCustomerTypes: { 'index': CustomerType }[] = [];

		@Emit('save')
		public save(): void {
			return;
		}

		@Emit('cancel')
		public cancel(event: Event): Event {
			const form = this.$refs.form as HTMLFormElement;
			this.reset([this.model], form);
			return event;
		}

		private requestSave(): void {
			if (!this.valid) return;

			this.loading = true;
			this.updateAllowedCustomerTypes();
			this.$paymentTypeServiceAdmin.create(this.model)
				.then(this.save)
				.catch(this.handleErrors)
				.finally(() => this.loading = false);
		}

		private updateAllowedCustomerTypes(): void {
			if (this.model) {
				this.model.allowedCustomerTypes = this.selectedCustomerTypes.map(ct => ct.index);
			}
		}

		private get customerTypesHeaders(): AsiListTableHeader[] {
			return [
				new AsiListTableHeader(this.$t('customer.type'), 'label', false, false, null),
			];
		}

		private get EnumHelper() {
			return EnumHelper;
		}

		private get CustomerType() {
			return CustomerType;
		}

	}
</script>

<style lang="scss" scoped>

</style>
